export default {
  name: 'yongzhou',
  adcode: '431100',
  mapName: '永州市',
  geoJsonPath: 'hunanmap/431100.json',
  backgroundImage: {
    png: '永州市_431100.png',
    webp: '永州市_431100.webp'
  },
  echartsMapStyle: {
    width: '776px',
    height: '661px',
    marginTop: 'auto',
    marginBottom: '76px',
  },
  imageSize: {
    width: 3580,
    height: 3144
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.135, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.003,  // X轴偏移百分比
      y: 0.001  // Y轴偏移百分比
    }
  },
  // 区县列表
  districts: ['永州市区', '祁阳市', '东安县', '双牌县', '道县', '江永县', '宁远县', '蓝山县', '新田县', '江华瑶族自治县'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（用于兜底展示）
    '永州市区': [111.914348, 26.142347],
    '永州市': [111.626348, 26.233347],
    // 区县坐标（来自 431100.json center）
    '祁阳市': [112.27734, 25.962397],
    '东安县': [111.962146, 26.494278],
    '双牌县': [111.672146, 25.892397],
    '道县': [111.241614, 25.762444],
    '江永县': [110.907276, 25.954112],
    '宁远县': [111.524529, 25.554112],
    '蓝山县': [111.408195, 25.215255],
    '新田县': [111.890341, 25.476927],
    '江华瑶族自治县': [110.877276, 25.452596]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    // 城区归并到“永州市区”
    if (s === '永州市') return '永州市区'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '零陵区': '431102',
    '冷水滩区': '431103',
    '祁阳市': '431121',
    '东安县': '431122',
    '双牌县': '431123',
    '道县': '431124',
    '江永县': '431125',
    '宁远县': '431126',
    '蓝山县': '431127',
    '新田县': '431128',
    '江华瑶族自治县': '431129'
  }
}